class Vertex {
  constructor (x, y, baseX, baseY) {
    this.baseX = baseX
    this.baseY = baseY
    this.x = x
    this.y = y
    this.vx = 0
    this.vy = 0
    this.targetX = 0
    this.targetY = 0
    this.friction = 0.05
    this.deceleration = 0.925
  }

  updateY (diffVal) {
    this.targetY = diffVal + this.baseY
    this.vy += this.targetY - this.y
    this.y += this.vy * this.friction
    this.vy *= this.deceleration
  }

  updateX (diffVal) {
    this.targetX = diffVal + this.baseX
    this.vx += this.targetX - this.x
    this.x += this.vx * this.friction
    this.vx *= this.deceleration
  }
}

export default Vertex



// WEBPACK FOOTER //
// ./src/lib/Vertex.js